module.exports = __webpack_public_path__ + "static/media/icon-07.a7de3796.png";